export default __webpack_public_path__ + "static/media/21.87c29597.png";